import React, { Fragment } from 'react';
import { getText } from 'src/utils/i18n';

import '../seo-related-search/index.scss';

const SeoSimilarProducts = ({
  similarCategoryPathList = [],
  domainName = '',
  i18n,
}) => {
  if (similarCategoryPathList.length < 2) return null;

  return (
    <div className="module-seoSimilarProducts">
      <div className="dotted-top similar-category ">
        <h3 className="title">
          {getText(
            i18n,
            'seoSimilarProducts_title_text',
            'Similar products in other categories:',
          )}
        </h3>
        {similarCategoryPathList.slice(1).map((pathList, index) => {
          return (
            <div className="crumb" key={index}>
              {pathList.map((item, _i) => {
                const url = `${domainName}${item.hrefObject.url}`;

                return (
                  <Fragment key={_i}>
                    <a className="dot-qr" href={url}>
                      {item.hrefObject.name}
                    </a>
                    {_i < pathList.length - 1 ? '>' : null}
                  </Fragment>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SeoSimilarProducts;
